import { ex } from '@fullcalendar/core/internal-common'

import type { ITeamMember, TeamStatusType } from './team.types'

export const enum enumOrderStatuses {
    PENDING = 'pending', // Ожидает назанчения
    CONFIRMED = 'confirmed', // Подтверждено и передано технику
    IN_PROGRESS = 'inProgress', // Техник выехал к заказчику
    ARRIVED = 'arrived', // Техник прибыл на место
    START_JOB = 'start_job', // Техник начал работу
    COMPLETED = 'completed', // Техник начал работу
    CANCELED = 'canceled', // Заказ отменен
}

export const enumStatysClasses = {
    [enumOrderStatuses.PENDING]: '--warn',
    [enumOrderStatuses.CONFIRMED]: '--success',
    [enumOrderStatuses.IN_PROGRESS]: '--warn',
    [enumOrderStatuses.ARRIVED]: '--info',
    [enumOrderStatuses.START_JOB]: '--info',
    [enumOrderStatuses.COMPLETED]: '--success',
    [enumOrderStatuses.CANCELED]: '--danger',
}

export const enumPillStatusesClasses = {
    [enumOrderStatuses.PENDING]: 'pill-pending',
    [enumOrderStatuses.CONFIRMED]: 'pill-success',
    [enumOrderStatuses.IN_PROGRESS]: 'pill-pending',
    [enumOrderStatuses.ARRIVED]: 'pill-on-leave',
    [enumOrderStatuses.START_JOB]: 'pill-busy',
    [enumOrderStatuses.COMPLETED]: 'pill-success',
    [enumOrderStatuses.CANCELED]: 'pill-dander',
}
export const enumPillStatusesText = {
    [enumOrderStatuses.PENDING]: 'pending',
    [enumOrderStatuses.CONFIRMED]: 'completed',
    [enumOrderStatuses.IN_PROGRESS]: 'in progress',
    [enumOrderStatuses.ARRIVED]: 'arrived',
    [enumOrderStatuses.START_JOB]: 'start job',
    [enumOrderStatuses.COMPLETED]: 'completed',
    [enumOrderStatuses.CANCELED]: 'canceled',
}

export type JobStatusesType = `${enumOrderStatuses}`
export interface IWorkGroup {
    id: number
    name: string
    dispatcher: ITeamMember
    executive: ITeamMember
    status?: TeamStatusType
    totalUsers: number
    randomUsers: ITeamMember[]
    groupMembers: ITeamMember[]
    address?: Address
    projects: number
    groupTeams: IgroupTeams[]
}

export interface IgroupTeams {
    id: number
    name: string
}

export interface Address {
    id: number
    street: string
    city: string
    state: string
    postalCode: string
    country: string
    latitude: string
    longitude: string
}

export interface IWorkGroupRequest extends Pick<IWorkGroup, 'status'> {
    members: number[]
    teams?: number[]
    address?: Partial<Address>
}

export interface IWorkGroupPage {
    executive: ITeamMember
    totalUsers: number
    randomUsers: ITeamMember[]
}

export interface ISchedulesWork {
    jobs: IJobWork[]
}

export interface ITasksWork {
    tasks: ITaskWork[]
}

export interface IMembersWork {
    users: (ITeamMember & {
        team: {
            id: number
            name: string
        }
    })[]
}

export interface IStatisticsWork {
    orderStatistics: OrderStatistics
    feedbackStatistics: FeedbackStatistics
    zoneStatistics: ZoneStatistics
    transactions: Transactions
}

export interface IJobWork {
    order: IOrderWork
    userAssignment: ITeamMember
}

export interface IOrderWork {
    id: number
    note: string
    startTime: Date
    endTime: Date
    status: JobStatusesType
    service: IServiceWork
}

export interface IServiceWork {
    id: number
    name: string
    category: {
        id: number
        name: string
    }
}

export interface ITaskWork {
    id: number
    startTime: Date
    endTime: Date
    status: JobStatusesType
    service: IServiceTask
    customer: ITeamMember
    address: Address
}

export interface IServiceTask {
    name: string
    category: IServiceCategory
}

export interface IServiceCategory {
    name: string
}

export interface FeedbackStatistics {
    total: number
    positive: string
    neutral: string
    negative: string
}

export interface OrderStatistics {
    total: OrderStatisticsElement
    open: OrderStatisticsElement
    kiv: OrderStatisticsElement
    closed: OrderStatisticsElement
}

export interface OrderStatisticsElement {
    value: number
    changed: string
}

export interface Transactions {
    mon: TransactionsElement
    tue: TransactionsElement
    wed: TransactionsElement
    thu: TransactionsElement
    fri: TransactionsElement
    sat: TransactionsElement
    sun: TransactionsElement
}

export interface TransactionsElement {
    thisWeek: number
    lastWeek: number
    cost: number
}

export interface ZoneStatistics {
    central: number
    north: number
    south: number
    east: number
    west: number
    total: number
}
